import data from './corpus.generated.json';
import type { CorpusEntry, CorpusIndex } from './corpusTypes';

/** The corpus index, precomputed at build time (see buildIndex.ts). */
export const CORPUS = data as unknown as CorpusIndex;

const byId = new Map<string, CorpusEntry>(CORPUS.entries.map((e) => [e.id, e]));
export function corpusEntry(id: string): CorpusEntry | undefined {
  return byId.get(id);
}

/** Chorales that count in statistics (derived duplicates, sonata movements and variation sets left out). */
export const COUNTED: CorpusEntry[] = CORPUS.entries.filter((e) => !e.derivedFrom && !e.kind);

/** Sonata movements in the index. */
export const SONATA_ENTRIES: CorpusEntry[] = CORPUS.entries.filter((e) => e.kind === 'sonata');

/** Preludes of The Well-Tempered Clavier, Book I (2–24) in the index. */
export const PRELUDE_ENTRIES: CorpusEntry[] = CORPUS.entries.filter((e) => e.kind === 'prelude' && e.collection.includes('Well-Tempered'));

/** Later piano music (imported from MIDI, read by rule). */
export const PIANO_ENTRIES: CorpusEntry[] = CORPUS.entries.filter((e) => e.kind === 'prelude' && !e.collection.includes('Well-Tempered'));

/** Theme-and-variations sets in the index. */
export const VARIATION_ENTRIES: CorpusEntry[] = CORPUS.entries.filter((e) => e.kind === 'variations');
